import React from 'react';
import { Alert, Box, Typography } from '@mui/material';
import SportsSoccerIcon from '@mui/icons-material/SportsSoccer';
import { GiftProduct, GiftProductType } from '../../../../models';
import { AsyncAutocomplete } from '../../../../components';

interface Props {
  product: Partial<GiftProduct>;
  onChange: (product: Partial<GiftProduct>) => void;
}

const PredictionTicketProductForm: React.FC<Props> = ({ product, onChange }) => {
  const handleBolaoSelect = (selectedBolao: any) => {
    if (selectedBolao) {
      onChange({
        ...product,
        type: GiftProductType.PredictionTicket,
        bolaoId: selectedBolao.id,
        bolaoName: selectedBolao.name,
      });
    } else {
      onChange({
        type: GiftProductType.PredictionTicket,
        bolaoId: undefined,
        bolaoName: undefined,
      });
    }
  };

  const selected = product.bolaoId
    ? { id: product.bolaoId, name: product.bolaoName || '(bolão selecionado)' }
    : null;

  return (
    <Box>
      <Alert severity="info" sx={{ mb: 2 }}>
        Esta recompensa dá ao cliente <strong>o direito de palpitar</strong> em um bolão que você já cadastrou.
        Quando o cliente cumprir a regra deste brinde, ele ganha o ticket de palpite — não um cupom.
        O cupom de verdade vem se ele acertar o placar.
      </Alert>
      <AsyncAutocomplete
        resource="boloes"
        label="Bolão vinculado"
        value={selected}
        onChange={handleBolaoSelect}
        getOptionLabel={(option: any) => option.name || ''}
        filters={{ status: ['draft', 'active'] }}
        required
        helperText="Apenas bolões em rascunho ou ativos podem receber novas recompensas de palpite."
        renderOption={(props, option: any) => (
          <li {...props} key={option.id}>
            <Box display="flex" alignItems="center" gap={2} width="100%">
              <SportsSoccerIcon sx={{ color: '#7869DF' }} />
              <Box>
                <Typography variant="body1">{option.name}</Typography>
                {option.homeTeamName && option.awayTeamName && (
                  <Typography variant="body2" color="text.secondary">
                    {option.homeTeamName} × {option.awayTeamName}
                  </Typography>
                )}
              </Box>
            </Box>
          </li>
        )}
      />
      {product.bolaoId && (
        <Box mt={3} p={2} border="1px solid" borderColor="divider" borderRadius={2}>
          <Typography variant="subtitle2" color="text.secondary" gutterBottom>
            Bolão selecionado:
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <SportsSoccerIcon sx={{ fontSize: 32, color: '#7869DF' }} />
            <Typography variant="h6">{product.bolaoName || product.bolaoId}</Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default PredictionTicketProductForm;
